// extracted by mini-css-extract-plugin
module.exports = {"highlightContainer":"HighLightContainer-module--highlight-container--o-QZf","verticalBar":"HighLightContainer-module--vertical-bar--39hRh"};